import { render, staticRenderFns } from "./SaleChannelDropdown.vue?vue&type=template&id=277c6827&"
import script from "./SaleChannelDropdown.vue?vue&type=script&lang=js&"
export * from "./SaleChannelDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports